import { getHotelCenterUtils } from '@bingads-webui-campaign/hotel-center-utils';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center-utils');
const state = globalContext.require('component/state/index');

export const {
  inlineDownloadUtils,
  bidMultiplierUtils,
} = getHotelCenterUtils({ state, i18n });
